import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var LogicExpression;
(function (LogicExpression) {
    let Type;
    (function (Type) {
        Type[Type["AND"] = 0] = "AND";
        Type[Type["OR"] = 1] = "OR";
        Type[Type["NOT"] = 2] = "NOT";
    })(Type = LogicExpression.Type || (LogicExpression.Type = {}));
    LogicExpression.get = createAccessors(arrayGetSet('logic_expressions'), {
        type: LogicExpression.Type.AND,
        conditions: [],
    });
})(LogicExpression || (LogicExpression = {}));
